import React from "react";
import "./Connect.css";
import {Link} from "react-router-dom";

const Connect = () => {

    const data = [
        {
            img: "images/whatsapp-icon.png",
            link:"/whatsapp"
        },
        {
            img: "images/twitter.png",
            link:"/twitter"
        },
        {
            img: "images/insta.png",
            link:"/insta"
        }
    ]

    return (
        <>
            <div className="connect_container">
                <h1>Connect With Us</h1>

                <div className="image">
                    {data.map((obj,index) => {
                        return (
                            <>
                            <Link to={obj.link}><img src={obj.img} key={index} alt="Loading" className="img" /></Link>
                            </>
                        )
                    })}
                </div>
            </div>

        </>
    )
}

export default Connect;